import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import { XMarkIcon } from "@heroicons/react/24/outline";

const AudioPlayerComponent = ({
  item,
  onPlay,
  onPause,
  onClose,
  file,
  feature_video,
  audio_file,
  image = "https://marvel-b1-cdn.bc0a.com/f00000000280066/d2snwnmzyr8jue.cloudfront.net/sca_9781338635201_270.jpeg",
  title = "Title",
  author = "author",
  playerRef,
  isPlayerOpen,
  setIsPlayerOpen,
  autoPlay = false,
  showSkipControls = false,
  onClickNext,
  onClickPrevious,
  onEnded,
  queueInfo,
  isUnlocked = true,
  onRequestAd,
}) => {
  const trackFile = file || item?.file;
  const trackFeatureVideo = feature_video || item?.feature_video;
  const trackAudioFile = audio_file || item?.audio_file;
  const trackImage = (image && image !== "https://marvel-b1-cdn.bc0a.com/f00000000280066/d2snwnmzyr8jue.cloudfront.net/sca_9781338635201_270.jpeg") ? image : (item?.image || image);
  const trackTitle = (title && title !== "Title") ? title : (item?.title || title);
  const trackAuthor = (author && author !== "author") ? author : (item?.author || author);
  const onPlayClick = () => {
    if (!isUnlocked) {
      if (playerRef?.current?.audio?.current) {
        try {
          playerRef.current.audio.current.pause();
        } catch (_) { }
      }
      onRequestAd && onRequestAd();
      return;
    }
    setIsPlayerOpen && setIsPlayerOpen(true);
    onPlay && onPlay();
  };

  const onPauseClick = () => {
    // DO NOT hide the player bar on pause.
    // The bar remains docked so user can resume playback or seek.
    onPause && onPause();
  };

  const handleClose = () => {
    if (playerRef?.current?.audio?.current) {
      try {
        playerRef.current.audio.current.pause();
      } catch (_) { }
    }
    setIsPlayerOpen && setIsPlayerOpen(false);
    onClose && onClose();
  };

  // Cloak audio source if item is locked so browser cannot stream or play
  const resolvedSrc = trackFile || trackFeatureVideo || trackAudioFile;
  const audioSrc = isUnlocked ? resolvedSrc : "";

  return (
    <div
      className="fixed shadow-2xl  bottom-0 left-0 w-screen z-50 animate-fade-up animate-ease-in animate-duration-300 backdrop-blur-md"
    >
      {/* Explicit Close / Dismiss Button */}
      {/* {(onClose || setIsPlayerOpen) && (
        <button
          onClick={handleClose}
          title="Close Player"
          aria-label="Close Player"
          className="absolute top-2 right-2 sm:right-4 z-30 p-1.5 rounded-full text-zinc-400 hover:text-white hover:bg-zinc-800/80 transition-all active:scale-95"
        >
          <XMarkIcon className="w-4 h-4" />
        </button>
      )} */}

      <AudioPlayer
        autoPlay={autoPlay}
        className="backdrop-blur-md bg-zinc-950/90 border-t border-zinc-800 text-white"
        ref={playerRef}
        controls={true}
        showSkipControls={showSkipControls}
        showJumpControls={false}
        onClickNext={onClickNext}
        onClickPrevious={onClickPrevious}
        onEnded={onEnded}
        src={audioSrc}
        style={{
          backgroundColor: "rgba(10, 10, 12, 0.92)",
        }}
        onPlay={onPlayClick}
        onPause={onPauseClick}
        customAdditionalControls={[
          <div key="track-meta" className="flex items-center">
            <img
              className="h-10 w-10 md:h-12 md:w-12 rounded-lg object-cover mr-2 md:mr-3 border border-zinc-800 shadow"
              src={trackImage}
              alt={trackTitle}
            />
            <div className="flex flex-col justify-center">
              <div className="flex items-center gap-1.5">
                <p className="text-white font-semibold max-w-[100px] sm:max-w-[160px] md:max-w-[220px] line-clamp-1 text-xs md:text-sm">
                  {trackTitle}
                </p>
                {queueInfo && (
                  <span className="hidden sm:inline-block px-1.5 py-0.5 rounded bg-secondary/20 text-secondary text-[9px] font-bold">
                    {queueInfo}
                  </span>
                )}
              </div>
              <p className="text-zinc-400 font-normal max-w-[100px] sm:max-w-[140px] md:max-w-[180px] line-clamp-1 text-[10px] md:text-xs">
                {trackAuthor}
              </p>
            </div>
          </div>,
        ]}
      />
    </div>
  );
};

export default AudioPlayerComponent;
